<template>
  <h1 class="title">Who We Are</h1>
  <div class="d2">
    <img class="img1" src="../assets/Monica.jpg" alt="Monica Kieber - Founder of In Your Hands." />
    <div class="d2a">Hi, I'm <span style="font-weight: 800;">Monica Kieber—founder of In Your Hands</span>, believer in small businesses, and someone who knows what it means to start from scratch.<br><br>

      I grew up in inner-city Chicago and made my escape the first chance I got—headed
      west with a heart full of hope and a love for open skies. I spent 15 years in Northern
      Colorado learning, growing, and finding my footing, and for the past 12 years, I've called
      the Pueblo area home. Colorado isn't just where I live—it's where I finally found the
      space to dream big and build something real.<br><br>

      I built this business because I've lived the reality that many small business owners face:
      working long hours, wearing too many hats, and struggling to be seen in a crowded,
      expensive advertising world. I knew there had to be a better way—and I wanted to
      create something that actually worked for real people.<br><br>

      I built this business because I've lived the reality that many small business owners face: working long hours, wearing too many hats, and struggling to be seen in a crowded, expensive advertising world. I knew there had to be a better way—and I wanted to create something that actually worked for real people.<br><br>

      Outside of work, I'm a mountain-loving, dog-walking, tea-drinking, EQ2 gamer who dreams
      big and believes deeply in building something that lasts. Whether you're a local
      entrepreneur or someone looking to grow your reach, I'd love to help put your business
      right where it belongs—in their hands.<br><br>
    </div><br><br>
    <div style="font-weight:800;">Eric K. - Co-Founder of In Your Hands</div>
    <img class="img2" src="../assets/Eric.jpg" alt="Eric Keiber - Co-Founder of In Your Hands." />
    <div class="d2c">
      My path to launching In Your Hands wasn't exactly traditional—but that's part of what makes it work. I spent my early working years delivering pizzas, then enlisted in the Navy at 24, just before 9/11. I served as an Avionics Technician aboard the USS John C. Stennis (CVN-74), deployed during RIMPAC 2004, and visited ports across the Pacific—Hawaii, Japan, Malaysia, Australia, and Canada. While on board, I made E5 and led my shop as a Petty Officer, even implementing a key change in how maintenance parts were processed—something that's still in place today.
      <br><br>After leaving the Navy, I took a sharp turn and went into trucking. I'd always wanted to drive professionally, so I earned my CDL and spent over 19 years on the road. I liked the independence and the responsibility of managing myself—plus, I genuinely enjoy driving. But after nearly two decades, the constant travel wore thin. I was ready for a life where I could finally be home.
      <br><br>That's when my sister brought up the idea that became In Your Hands, and I knew it was the right move. Now I'm working to build something that matters in my own community—helping local businesses reach real people through a mailer that's cost-effective, useful, and genuinely local. It feels good to be part of something that connects people, right here at home.
    </div>
</div>
<div class="d3">
  <img class="img3" src="../assets/staff.jpg" alt="Monica, Eric, and two other staff." />
</div>
</template>


<script>
export default {
  name: 'about',
  data() {
    return {
      isMobile: false,
    }
  },
  mounted() {
    this.windowSize();
    window.addEventListener('resize', this.windowSize);    
    this.updateViewport();    
    window.addEventListener('resize', this.updateViewport); 
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateViewport);
    window.removeEventListener('resize', this.windowSize);
  },
  methods: {    
    windowSize () {
      if (window.innerWidth <= 900) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    updateViewport() {
      this.minw = window.screen.width*.75 + 'px';                          
    },
  }
}
</script>

<style scoped>
  img {
    border-radius: 10px;
  }
  .d1 {
    font-family: 'Anonymous Pro';
    font-size: 60px;
    color: v-bind(colorRed);
    position:absolute;
    min-width: v-bind(minw);
    top: 130px;
    display: flex;
    justify-content: center;
    width: 100%;
    text-shadow:0 4px 4px rgba(0, 0, 0, 0.35);
  }
  .d2 {
    width: 60%;
    margin-left: 20%;
    margin-top: 20px;
    margin-bottom: 50px;
    font-family: 'Akatab';
    color: v-bind(colorRed);
    font-size: 20px;
  }
  .d2c {
    margin-top: 20px;
  }
  .d3 {
    width: 100%; 
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
  }
  .img1 {
    width: 25%;
    float: right;
    margin-left: 20px;
    margin-bottom: 10px;
    margin-right:20px;
  }
  .img2 {
    width: 25%;
    float: left;
    /* margin-left: 20px; */
    margin-right: 20px;
    margin-bottom: 10px;
    margin-top: 20px;
  }
  .img3 {
    width: 35%;    
  }
  .title {
  font-family: 'Anonymous Pro';
  font-size: 60px;
  color: v-bind(colorRed);
  position:absolute;
  min-width: v-bind(minw);
  top: 130px;
  display: flex;
  justify-content: center;
  width: 100%;
  text-shadow:0 4px 4px rgba(0, 0, 0, 0.35);
}
@media only screen and (max-width: 900px) {
  
  .d2 {
    width: 90%;
    margin-left: 5%;
    font-size: 17px;
  }
  .img1 {
    width: 35%;
    margin: 8px;
  }
  .img2 {
    width: 35%;
    margin-bottom: 0;
  }
  .img3 {
    width: 90%;
  }
  .title {
    font-size: 50px;
  }
}

</style>